import * as React from 'react';

export const TopView = (props: React.SVGProps<SVGSVGElement>) => (
	<svg
		xmlns="http://www.w3.org/2000/svg"
		xmlnsXlink="http://www.w3.org/1999/xlink"
		viewBox="0 0 224.3 478.8"
		{...props}
	>
		<defs>
			<linearGradient
				id="linear-gradient"
				x1="0"
				y1="0.5"
				x2="1"
				y2="0.5"
				gradientUnits="objectBoundingBox"
			>
				<stop offset="0" stopColor="#dddede" />
				<stop offset="1" stopColor="#acacac" />
			</linearGradient>
			<linearGradient
				id="linear-gradient-2"
				x1="0"
				y1="0"
				x2="1"
				y2="0"
				xlinkHref="#linear-gradient"
			/>
			<linearGradient
				id="linear-gradient-4"
				x1="0"
				y1="0.5"
				x2="1"
				y2="0.5"
				xlinkHref="#linear-gradient"
			/>
			<linearGradient
				id="linear-gradient-5"
				x1="0"
				y1="0.5"
				x2="1"
				y2="0.5"
				xlinkHref="#linear-gradient"
			/>
			<linearGradient
				id="linear-gradient-6"
				x1="0.667"
				y1="0.538"
				x2="1"
				y2="0.462"
				gradientUnits="objectBoundingBox"
			>
				<stop offset="0" stopColor="#484747" />
				<stop offset="0" stopColor="#4c4b4b" />
				<stop offset="0" stopColor="#616161" />
				<stop offset="0.1" stopColor="#727272" />
				<stop offset="0.1" stopColor="#7d7d7d" />
				<stop offset="0.1" stopColor="#848484" />
				<stop offset="0.2" stopColor="#868686" />
				<stop offset="0.4" stopColor="#d2d2d2" />
				<stop offset="0.4" stopColor="#f2f2f2" />
				<stop offset="0.5" stopColor="#fff" />
				<stop offset="0.6" stopColor="#fff" />
				<stop offset="0.7" stopColor="#d2d2d2" />
				<stop offset="0.8" stopColor="#bdbdbd" />
				<stop offset="0.9" stopColor="#868686" />
			</linearGradient>
			<linearGradient
				id="linear-gradient-7"
				x1="1"
				y1="0.25"
				x2="1"
				y2="0.25"
				xlinkHref="#linear-gradient-6"
			/>
			<linearGradient
				id="linear-gradient-8"
				x1="0"
				y1="0.48"
				x2="1"
				y2="0.4"
				xlinkHref="#linear-gradient-6"
			/>
			<linearGradient
				id="linear-gradient-9"
				x1="0.75"
				y1="0.5"
				x2="0.5"
				y2="0.667"
				xlinkHref="#linear-gradient-6"
			/>
			<linearGradient
				id="linear-gradient-10"
				x1="-0.143"
				y1="0.519"
				x2="1.286"
				y2="0.519"
				xlinkHref="#linear-gradient-6"
			/>
			<linearGradient
				id="linear-gradient-11"
				x1="-0.333"
				y1="0.5"
				x2="1"
				y2="0.5"
				xlinkHref="#linear-gradient-6"
			/>
			<linearGradient
				id="linear-gradient-12"
				x1="-1"
				y1="0.571"
				x2="1"
				y2="0.571"
				xlinkHref="#linear-gradient-6"
			/>
			<linearGradient
				id="linear-gradient-13"
				x1="-0.333"
				y1="0.458"
				x2="1.333"
				y2="0.458"
				xlinkHref="#linear-gradient-6"
			/>
			<linearGradient
				id="linear-gradient-14"
				y1="0.556"
				x2="1.5"
				y2="0.556"
				gradientUnits="objectBoundingBox"
			>
				<stop offset="0" stopColor="#706e73" />
				<stop offset="1" stopColor="#49484b" />
			</linearGradient>
			<linearGradient
				id="linear-gradient-15"
				x1="0"
				y1="0.6"
				x2="1"
				y2="0.6"
				xlinkHref="#linear-gradient-14"
			/>
			<linearGradient
				id="linear-gradient-16"
				x1="0.667"
				y1="0.462"
				x2="0.667"
				y2="0.538"
				gradientUnits="objectBoundingBox"
			>
				<stop offset="0" stopColor="#fff" />
				<stop offset="1" />
			</linearGradient>
			<linearGradient
				id="linear-gradient-17"
				x1="1"
				y1="0.25"
				x2="1"
				y2="0.25"
				xlinkHref="#linear-gradient-16"
			/>
			<linearGradient
				id="linear-gradient-18"
				x1="1"
				y1="0.44"
				x2="-0.667"
				y2="0.48"
				xlinkHref="#linear-gradient-16"
			/>
			<linearGradient
				id="linear-gradient-19"
				x1="0.333"
				y1="0.538"
				x2="1"
				y2="0.462"
				xlinkHref="#linear-gradient-6"
			/>
			<linearGradient
				id="linear-gradient-20"
				x1="0"
				y1="0.5"
				x2="1"
				y2="0.5"
				xlinkHref="#linear-gradient-6"
			/>
			<linearGradient
				id="linear-gradient-21"
				x1="0"
				y1="0.5"
				x2="1"
				y2="0.5"
				xlinkHref="#linear-gradient-14"
			/>
			<linearGradient
				id="linear-gradient-22"
				x1="0"
				y1="0.55"
				x2="0.958"
				y2="0.55"
				xlinkHref="#linear-gradient-14"
			/>
			<linearGradient
				id="linear-gradient-23"
				x1="1"
				y1="0.462"
				x2="-0.333"
				y2="0.538"
				xlinkHref="#linear-gradient-16"
			/>
		</defs>
		<g id="Topview" transform="translate(-275 -9)" opacity="0.9">
			<path
				id="Pfad_1"
				data-name="Pfad 1"
				d="M469.7,306.5l-13.5,3v-.1l-.1,2.8c-.3,10.3-.5,21.9-.5,32.1,0,22.4,0,38,2.3,41.3a96,96,0,0,0,5.7-18.7c3.5-14.8,5.6-34.8,6.2-59.5v-.7l-.1-.2Zm-13.5,2.7v0ZM400.9,124.3l4.2.3ZM455.3,143.6Zm14.4,162.9-13.5,3v-.1l-.1,2.8c-.3,10.3-.5,21.9-.5,32.1,0,22.4,0,38,2.3,41.3a96,96,0,0,0,5.7-18.7c3.5-14.8,5.6-34.8,6.2-59.5v-.7l-.1-.2Zm-13.5,2.7v0ZM455.3,143.6Zm-54.4-19.3,4.2.3Zm0,0,4.2.3ZM455.3,143.6Zm14.4,162.9-13.5,3v-.1l-.1,2.8c-.3,10.3-.5,21.9-.5,32.1,0,22.4,0,38,2.3,41.3a96,96,0,0,0,5.7-18.7c3.5-14.8,5.6-34.8,6.2-59.5v-.7l-.1-.2Zm-13.5,2.7v0ZM455.3,143.6Zm-54.4-19.3,4.2.3Zm0,0,4.2.3ZM455.3,143.6ZM455.3,143.6Zm-50.2-18.9-4.2-.3Zm64.6,181.8-13.5,3v-.1l-.1,2.8c-.3,10.3-.5,21.9-.5,32.1,0,22.4,0,38,2.3,41.3a96,96,0,0,0,5.7-18.7c3.5-14.8,5.6-34.8,6.2-59.5v-.7l-.1-.2Zm-13.5,2.7v0ZM455.3,143.6Zm-50.2-18.9-4.2-.3Zm-4.2-.4,4.2.3ZM455.3,143.6Zm.9,165.6v0Zm13.5-2.7-13.5,3v-.1l-.1,2.8c-.3,10.3-.5,21.9-.5,32.1,0,22.4,0,38,2.3,41.3a96,96,0,0,0,5.7-18.7c3.5-14.8,5.6-34.8,6.2-59.5v-.7l-.1-.2ZM455.3,143.6Zm-54.4-19.3,4.2.3Zm0,0,4.2.3ZM455.3,143.6Zm.9,165.6v0Zm13.5-2.7-13.5,3v-.1l-.1,2.8c-.3,10.3-.5,21.9-.5,32.1,0,22.4,0,38,2.3,41.3a96,96,0,0,0,5.7-18.7c3.5-14.8,5.6-34.8,6.2-59.5v-.7l-.1-.2ZM455.3,143.6Zm-54.4-19.3,4.2.3Zm55.3,184.9v0Zm13.5-2.7-13.5,3v-.1l-.1,2.8c-.3,10.3-.5,21.9-.5,32.1,0,22.4,0,38,2.3,41.3a96,96,0,0,0,5.7-18.7c3.5-14.8,5.6-34.8,6.2-59.5v-.7l-.1-.2Zm-13.5,2.7v0Zm13.5-2.7-13.5,3v-.1l-.1,2.8c-.3,10.3-.5,21.9-.5,32.1,0,22.4,0,38,2.3,41.3a96,96,0,0,0,5.7-18.7c3.5-14.8,5.6-34.8,6.2-59.5v-.7l-.1-.2Z"
				fill="currentColor"
				opacity="0.6"
			/>
			<path
				id="Pfad_2"
				data-name="Pfad 2"
				d="M499.2,181.8h0l-.2-.2-.2-.2-.4-.3-.9-.7-.3-.3-1.8-1.3-1.2-.8-1-.7-.8-.5-.9-.5-.7-.4-2.2-1.2-1.1-.5-1.3-.6-.9-.4-1.8-.7-.2-14.9v-.3l-9.8,4.5v.3l.2,8.1-.7-.1-1.3-1.2-.2-5.9v-.3q-.183-6.57-1-13.1c-.1.6-1.1,1.3-1.2,2.1-.6,3.7-5.8,51.2-7.2,67q-4.334,45.1-5.8,90.4v.2l13.5-3,.2.1v-.3l1.2-83.5.6-45v-1.8l.5-.1,1.4,2.1c-.3,16.5-1.4,114-1.8,129.2v.3l11.9,5.7v-.3l.2-13.5a28.439,28.439,0,0,0,1.9-10.2,20.1,20.1,0,0,0-1.7-8.7c.4-34,.6-69.8.2-75.7-.3-4.3-.5-11.7-.7-19.4l15.6,2.3v-5.7ZM476.1,443.1l-2.8-.1-.1.3c-1.4,3-4.1,6.4-8.4,9.9a138.8,138.8,0,0,1-22.7,12.5l1.4-2.8,5.3-10.8.7-1.5.4-.8.7-1.5c3.5-8,3.3-8.7,7.4-18.5l.4-1,.2-.5a49.464,49.464,0,0,0-2.8-12.6c-3.5-9.5-9.4-14.9-17.2-15.6h-.5c.2-4.3,3.8-106.9,5.4-129,1.4-19.2,3.9-41.6,4.6-47.8l-1.3.4-1,.1-1.4-.1a559.009,559.009,0,0,0-57.4-4.3c-21.3,0-54.3,3.8-57.3,4.3a7.561,7.561,0,0,1-2.6,0l-.4-.1-.3-.1a5.559,5.559,0,0,1-1.7-.9c.6,4.9,3.2,28.4,4.6,48.5q3.2,64.578,5.4,129.2h1.5c-2,.4-7.4,1.6-10.3,3.5-3.5,2.3-6.7,9.9-8.1,16.2l-2.3,8.8.2.4.3.7c4.1,9.8,3.9,10.4,7.4,18.5l.5,1,.6,1.3.7,1.5c.7,1.5,1.4,3.1,2.2,4.5l1,2,2.2,4.3,1.4,2.8c-.5-.2-16.5-7.4-22.7-12.5a32.2,32.2,0,0,1-7.9-9l-.2-.3-3.4-1.1-9-18.7v.7c.5,9.4,1.4,18.4,2.8,21.9,2.1,5.4,4,6.4,5,9.9a62.569,62.569,0,0,0,2.9,7.6s38.7,23.5,87.5,23.5,87.5-23.5,87.5-23.5a62.569,62.569,0,0,0,2.9-7.6c1-3.5,2.9-4.5,5-9.9,1.2-3.2,2-10.5,2.5-18.7v-.6l-8.8,15.6Zm-36.4,8.2a81.1,81.1,0,0,1-52.8,18.8c-20.2,0-41.1-7.8-52.8-18.8s-12.8-30.7-12.8-30.7a26.69,26.69,0,0,0,4.8,4.5l1.1.8.7.5.8.5.5.3.8.4.5.2.8.4.5.2,1.5.5.6.2,1.5.3c8,1,43.6,1.5,51.5,1.5l12.2-.1h11.5l4-.1h.1l2-.1,5.9-.2h1l2.4-.1h.9l4.4-.2h.9l2.2-.1h.6l.8-.1.8-.1,2-.2,1.6-.3.6-.2,1.5-.5.5-.2.8-.4.4-.2.9-.5,1.1-.7,1-.7.7-.5.3-.2a26.69,26.69,0,0,0,4.8-4.5s-1.3,19.5-13.1,30.6ZM436,27.4l.8.7.1-.1Zm27.4,43.4-.2-.9-.3-.9.3,1.2.4,1.5-.2-.9Zm.1-22.3.4.6Zm1.7,29.8-.2-.8.3,1.4-.1-.6Zm1.3,6-.1-.5.1.5.1.8Zm1.3,7.7-.1-.5v.3l.1.4Zm1.2,6.8v-.9l-.1-1.9h-.3l.1,2.4v.8l1.6,28.2-9.5,8.4.2.2,9.6-8.5L469,98.8ZM334.9,30Zm-31.2,95.4L304.8,99v-.9l-.2-.6v.9l-1.1,27,9.5,11.1.2-.2Zm3.5-41.1-.1.8.1-.8.1-.5ZM305.9,92v.3l.1-.4ZM318,312.1v-1c-.9-33.3-3.7-68.5-5.9-92.3-1.5-15.8-6.6-63.3-7.2-67-.1-.8-1.1-1.6-1.2-2.1q-1.057,9.616-1.2,19.3l-1.3,1.2-.6.1.2-7.4v-.3l-9.9-5.6v.3l-.2,15.3a46.69,46.69,0,0,0-5,2.3l-1.8.9-1.8,1a39.8,39.8,0,0,0-3.8,2.5l-.8.6-.9.7a3,3,0,0,1-.7.5l-.4.3-.4.4v5.8l15.4-2.2,7.4-1.1V182l2.8-4,1.4-2.1.5.1v1.8l.6,45,1.2,84.5v.4l-2-.5h-.1l-7.5,3.9-4.4,2v.3l4.5-2.1,7.5-3.9h.1l2,.5c.6,24.4,2.7,44.2,6.2,58.8,2.8,12,4.7,16.8,5.7,18.7,2.3-3.3,2.3-18.9,2.3-41.3l-.7-32Zm-24.6-29.6c-1.2.5-2.9,1.5-2.9,3.1,0,2.5-.2,8.1.6,9a5.244,5.244,0,0,0,2.5,1,78.6,78.6,0,0,0-.2-13.1Z"
				fill="currentColor"
				opacity="0.6"
			/>
			<path
				id="Pfad_3"
				data-name="Pfad 3"
				d="M484.3,362.5a140.648,140.648,0,0,1-1-16.6l.4-33v.3l-11.9-5.7a313,313,0,0,1-6.3,59.8c-4.7,19.9-7.2,22.7-8.9,20.7s-2.6-38-1.6-75.9,4.5-77.8,6-93.4q3.3-33.628,7.1-67.2c.6-3.8,1.5-6.8,2.9-6.8,1.1,0,2,7.5,2.4,17.2l9.8-4.5v-.2s2.5-30.3,2.5-49.8-2.5-42.7-2.5-42.7a68.392,68.392,0,0,1-6.3-11.9c-1.9-5.3-2.8-9-2.8-9s-25.8-22.6-32-26.5C435.9,13.5,408.8,9,387.3,9s-49.4,4.5-55.6,8.3-32,26.5-32,26.5-.9,3.6-2.8,9-6.3,11.9-6.3,11.9-.5,4.3-1,10.8V76c-.7,8.5-1.5,20.5-1.5,31.4,0,18.8,2.3,47.4,2.5,49.7l9.9,5.6c.4-10,1.3-17.9,2.4-17.9,1.3,0,2.2,2.9,2.9,6.8.6,3.8,5.6,51.5,7.1,67.2,1.5,15.6,5,55.5,6,93.4s.1,74-1.6,75.9c-1.7,2-4.2-.8-8.9-20.7-4.7-19.8-5.9-45-6.2-59.7h-.1l-7.5,3.9-4.5,2.1v-.3l4.4-2,7.5-3.9h.1c-.4-15-1.5-112.7-1.8-129.2l-2.8,4v2.3l-7.4,1.1c-.2,7.7-.4,15.2-.7,19.4-.5,5.9-.2,42,.2,76.1a27.3,27.3,0,0,0,.2,18l.6,46.9a141.65,141.65,0,0,1-1,16.6,527.4,527.4,0,0,0-.9,61.5l9,18.7,3.4,1.1a15.842,15.842,0,0,1-1.5-4.3c-.5-3.5-1-22.1-1-26.1,0-3.8.1-6.1,1.7-6.3h.1c1.6-.1,10.8,12,15.2,21.6l2.3-8.8c1.4-6.3,4.6-13.9,8.1-16.2a33,33,0,0,1,10.3-3.5h-1.5s-3.8-106.6-5.4-129.2c-1.4-20.1-4.1-43.6-4.6-48.5-1.7-1.2-3.2-3.7-3.9-8-1.4-8.7-8.2-65.9-7.6-73l.4-3.6a31.9,31.9,0,0,1,20.2-25,138,138,0,0,1,53.3-8.7c18.8,0,36.5,1.8,53.4,8.7A32.2,32.2,0,0,1,461,141.6c.5,7.1-6.2,64.3-7.7,73-.9,5.5-3,7.8-5.2,8.7-.7,6.2-3.2,28.5-4.6,47.8-1.6,22.1-5.2,124.7-5.4,129h.5c7.8.7,13.7,6.1,17.2,15.6a49.5,49.5,0,0,1,2.8,12.6c4.4-9.5,13.4-21.2,15-21.1h.1c1.6.2,1.7,2.4,1.7,6.3s-.4,22.5-.9,26.1a15.333,15.333,0,0,1-1.1,3.5l2.8.1,8.9-15.8.7-16.3c.2-13-.5-41.9-1.5-48.6ZM290.5,285.6c0-1.6,1.7-2.6,2.9-3.1a53.5,53.5,0,0,1,.3,13.1,4.843,4.843,0,0,1-2.5-1c-.9-.8-.7-6.5-.7-9ZM336.4,28.8l-1.5,1.1-2.4,2-.9.8-.1.1-1.1,1a74.394,74.394,0,0,0-5.5,6.2l-.7.8A75,75,0,0,0,317.1,52l-.8,1.6-.8,1.6-.4,1-.1.2a7,7,0,0,0-.5,1.3l-.5,1.2-1.1,2.9-.3,1-1,3.2-.1.3-.5,1.5-.5,1.9v.1l-.5,1.9-.1.5-.3,1.3-.1.5-.3,1.1-.4,1.5-.1.5-.4,1.6-.1.6-.6,2.9-.3,1.3-.1.5-.2.8-.2.8-.1.7-.1.7-.1.3-.1.6-.3,1.5-.1.6-.2,1.4v.2l-.1.4v.1l-.1.7-.1.5v.2q-.239,1.859-.6,3.7v.3l-.1.8-.2-.4v.9l-1.1,26.4,9.5,11-.2.2-9.5-11.1,1.1-27v-.9a27.2,27.2,0,0,1-1.8-6.1l-.1-2.6-.1-3v-8l.1-2.7.1-2.7.1-2,.1-1.3.3-3.3.4-2.8a36,36,0,0,1,6.3-14.2l3.8-5.3,1.3-1.8.8-1A41,41,0,0,1,333.5,28c3-.7,2.9.8,2.9.8ZM437,27.7l-.2.3-.1.1-.8-.7-.1-.1-2.1-1.5-.8-.5-.4-.2-.8-.5-.4-.2-.6-.3-2.3-1.2-.3-.1a54,54,0,0,0-8.7-3.1,134.845,134.845,0,0,0-65.2,0l-2.2.6a30,30,0,0,0-3.2,1.1l-2.3.9-.7.3-2.7,1.3-.9.5-.5.3h-.1l-.2.1a22.3,22.3,0,0,0-4.5,3.3l-.2-.3-.2-.2-.4-.2-.2-.1h-1.1l-1.5.4-.3.1a39,39,0,0,1,21.4-11.4,139.4,139.4,0,0,1,64.8,0,41.2,41.2,0,0,1,21.5,11.5l-.5-.2-.5-.2-.5-.1-.9-.1h-.2l-.5.1-.3.1-.2.1-.1.1ZM460.9,136l9.5-8.4-1.6-28.2v-.8l-.1-.8v-.3l-.3-2-.3-1.7v-.2l-.1-.5-.1-.7v-.1l-.1-.4v-.3l-.1-.5v-.2l-.1-.5-.2-1.1-.1-.5-.1-.5v-.2l-.1-.5v-.1l-.2-.8-.1-.7-.2-.8-.2-.8-.1-.5-.2-.8-.3-1.3-.3-1.4-.3-1.2V79l-.3-1.4-.5-2.2-.3-1.1-.4-1.6-.2-.8v-.1l-.4-1.5-.3-1.2-.1-.3-.2-.8-.5-1.5-.2-.7-.3-1.1-.4-1.2-.5-1.5-2.1-5.4-.5-1.2-.1-.2-.7-1.4-1.4-2.7-.5-.9c-1.4-2.4-2.8-4.7-4.1-6.6l-.6-.9-1.2-1.6-.7-.8-.7-.8-1.6-1.9-1.6-1.7-.8-.8-.4-.4-.3-.4-.5-.5-3.5-3.2a3,3,0,0,0-.7-.5,7.863,7.863,0,0,0-1.5-1.1s-.1-1.5,2.8-.5,12,5,17.8,12.6l.8,1,1.3,1.8,2,2.8,1,1.4.4.6.4.6a36,36,0,0,1,6.6,17l.5,8.3V79c.1,6,0,11.3-.1,12.7-.1,2.1-1.4,5.3-1.9,6.6v.9l1.7,28.9-9.6,8.5.1-.6Z"
				fill="currentColor"
				opacity="0.6"
			/>
			<path
				id="Pfad_4"
				data-name="Pfad 4"
				d="M499.2,181.8v5.8l-15.6-2.3-7.2-1V182l-2.8-4-1.4-2.1-.5.1-4.2.7,1.7-10.2,2.6,2.4,1.3,1.2.7.1,4,.5h.3a42.726,42.726,0,0,1,5.4,1.8l1.8.7.9.4,1.3.6,1.1.5,2.2,1.2.7.4.9.5.8.5,1,.7,1.2.8,1.8,1.3.3.3.9.7.4.3.2.2.2.2h0Zm-192.5-5-4.2-.7-.5-.1-1.4,2.1-2.8,4v2.3l-7.4,1.1L275,187.7v-5.8l.4-.4.4-.3.7-.5.9-.7.8-.6,2.6-1.7,1.2-.8,1.8-1,1.8-.9a46.7,46.7,0,0,1,10.6-4.2h.3l4-.5.6-.1,1.3-1.2,2.6-2.4,1.7,10.2Z"
				fill="currentColor"
				opacity="0.6"
			/>
			<path
				id="Pfad_5"
				data-name="Pfad 5"
				d="M480.3,290.3l.2,5.3a5.665,5.665,0,0,0,2.6-1c.8-.9.6-6.5.6-9,0-1.6-1.7-2.6-2.9-3.1a53.518,53.518,0,0,0-.5,7.8Zm-186.5,0-.2,5.3a4.843,4.843,0,0,1-2.5-1c-.8-.9-.6-6.5-.6-9,0-1.6,1.7-2.6,2.9-3.1a76.881,76.881,0,0,1,.4,7.8Z"
				opacity="0.1"
			/>
			<path
				id="Pfad_6"
				data-name="Pfad 6"
				d="M472.2,176l1.4,2.1c-.3,16.5-1.4,114-1.8,129.2v.3a313,313,0,0,1-6.3,59.8c-4.7,19.9-7.2,22.7-8.9,20.7s-2.6-38-1.6-75.9,4.5-77.8,6-93.4q3.3-33.628,7.1-67.2c.6-3.8,1.5-6.8,2.9-6.8,1.1,0,2,7.5,2.4,17.2v.3l.2,8.1-.7-.1-1.3-1.2-.2-5.9v-.3q-.183-6.57-1-13.1c-.1.6-1.1,1.3-1.2,2.1-.6,3.7-5.8,51.2-7.2,67q-4.334,45.1-5.8,90.4v.1l-.1,2.8c-.3,10.3-.5,21.9-.5,32.1,0,22.4,0,38,2.3,41.3a96,96,0,0,0,5.7-18.7c3.5-14.8,5.6-34.8,6.2-59.5v-1l1.2-83.5.6-45v-1.8l.6-.1Z"
				fill="currentColor"
				opacity="0.6"
			/>
			<path
				id="Pfad_7"
				data-name="Pfad 7"
				d="M467.4,176.8l4.2-.7v1.8l-.6,45c-.4,32.5-.9,72.6-1.2,83.5v1c-.6,24.7-2.7,44.7-6.2,59.5a88.6,88.6,0,0,1-5.7,18.7c-2.3-3.3-2.3-18.9-2.3-41.3,0-10.1.2-21.8.5-32.1l.1-2.8v-.1c1-32.7,3.6-67,5.8-90.4,1.5-15.8,6.6-63.3,7.2-67,.1-.8,1.1-1.6,1.2-2.1.4,2.9.8,7.4,1,13.1v.3l.2,5.9-2.6-2.4-1.6,10.1Z"
				fill="url(#linear-gradient)"
			/>
			<path id="Pfad_8" data-name="Pfad 8" d="M473.6,170.3h0Z" fill="url(#linear-gradient-2)" />
			<path
				id="Pfad_9"
				data-name="Pfad 9"
				d="M317.5,388c-1.7,2-4.2-.8-8.9-20.7-4.7-19.8-5.9-45-6.2-59.7l2,.5c.6,24.4,2.7,44.2,6.2,58.8,2.8,12,4.7,16.8,5.7,18.7,2.3-3.3,2.3-18.9,2.3-41.3,0-10.1-.2-21.8-.5-32.1v-1c-.9-33.3-3.7-68.5-5.9-92.3-1.5-15.8-6.6-63.3-7.2-67-.1-.8-1.1-1.6-1.2-2.1q-1.057,9.616-1.2,19.3l-1.3,1.2-.6.1.2-7.4v-.3c.4-10,1.3-17.9,2.4-17.9,1.3,0,2.2,2.9,2.9,6.8.6,3.8,5.6,51.5,7.1,67.2,1.5,15.6,5,55.5,6,93.4C320.1,350,319.2,386,317.5,388Z"
				fill="currentColor"
				opacity="0.6"
			/>
			<path id="Pfad_10" data-name="Pfad 10" d="M301.1,170.3h0Z" fill="url(#linear-gradient-2)" />
			<path
				id="Pfad_11"
				data-name="Pfad 11"
				d="M304.3,307.7l-2-.5c-.4-15-1.5-112.7-1.8-129.2l1.4-2.1.5.1v1.8l.6,45,1.2,84.5.1.4Z"
				fill="currentColor"
				opacity="0.6"
			/>
			<path
				id="Pfad_12"
				data-name="Pfad 12"
				d="M318.4,344.2c0,22.4,0,38-2.3,41.3a96,96,0,0,1-5.7-18.7,295.3,295.3,0,0,1-6.2-58.8l-2-.5v-.3l2,.5v-.4L303,222.8l-.6-45V176l4.2.7-1.7-10.2-2.6,2.4a152.645,152.645,0,0,1,1.2-19.3c.1.6,1.1,1.3,1.2,2.1.6,3.7,5.8,51.2,7.2,67,2.2,23.8,5,59,5.9,92.3v1C318.2,322.4,318.4,334.1,318.4,344.2Z"
				fill="url(#linear-gradient-4)"
			/>
			<path
				id="Pfad_13"
				data-name="Pfad 13"
				d="M455.3,143.6Zm-9.5,80,1-.1Zm-40.7-98.9-4.2-.3Z"
				fill="#21292b"
			/>
			<path
				id="Pfad_14"
				data-name="Pfad 14"
				d="M461,141.4s-10.4-25.8-72.8-25.8c-47.8,0-67.9,15.1-74.8,22.2a24.731,24.731,0,0,0-.4,3.6c-.5,7.1,6.2,64.3,7.6,73,.7,4.4,2.2,6.8,3.9,8a7,7,0,0,0,1.7.9l.3.1.4.1a5.7,5.7,0,0,0,2.6,0c3-.5,36.1-4.3,57.3-4.3a558.986,558.986,0,0,1,57.4,4.3l1.4.1,1-.1,1.3-.4c2.2-.9,4.3-3.3,5.2-8.7q5.451-36.322,7.9-73Zm-10.5,72.5c-.5,3.1-1.5,5.2-2.8,6.1a3.767,3.767,0,0,1-2.8.5h-.5l-1-.1-2.2-.3-.8-.1-.6-.1-1-.1-1.1-.1-1.7-.2-1.4-.1-2.5-.3-7.5-.7-1.6-.1-1.7-.2h-.5l-2.2-.2-.7-.1-3.3-.3h-.7l-2.2-.2-.8-.1-3.2-.2-1-.1-3-.2c-5.9-.3-11.7-.6-16.9-.6-21.8,0-55.1,3.8-57.8,4.3a3.767,3.767,0,0,1-2.8-.5c-1.3-.9-2.3-3.1-2.8-6.1-1.3-7.9-6.8-54.8-7.6-69l.2-.3c6.8-6.7,26.6-20.7,72-20.7h5.9l2.3.1,4.4.2,4.2.3,1.5.1,2,.2,2,.2,1.9.2.8.1,1.3.2,2.5.4,1.2.2,8,1.7h.1l2.9.8,2.7.8,3.7,1.3,1.2.5.2.1,1.1.4,2,.9,1,.5.3.2,1.7.8,1.8,1,.8.5,1.9,1.2,1.1.8.7.5.6.5,1.2.9,1.1.9,1,.9.4.4.4.4.4.4.4.4.3.4.8,1,1.2,1.6.3.5v.1l.2.3q-2.4,33.706-7,67.2Zm2.1,206.6s-1.1,19.7-12.8,30.7A81.1,81.1,0,0,1,387,470c-20.2,0-41.1-7.8-52.8-18.8s-12.8-30.7-12.8-30.7a26.69,26.69,0,0,0,4.8,4.5,37.6,37.6,0,0,0,10,20.5,77,77,0,0,0,50.9,20.4l4.2-.1,2.1-.2,1.4-.1,3.6-.5,3.2-.6,1.7-.4,1.7-.4,1.6-.5,1.6-.5,1.5-.5.2-.1,3-1.1a47.289,47.289,0,0,0,4.7-2l1.5-.7,2.7-1.3,3-1.7,1.4-.8,1.3-.8h.1l1.3-.8,1.3-.9,1.1-.8a36.3,36.3,0,0,0,16.9-26.2,30.74,30.74,0,0,0,4.4-4.4ZM471.7,176v1.8l-.6,45c-.4,32.5-.9,72.6-1.2,83.5v1c-.6,24.7-2.7,44.7-6.2,59.5a88.6,88.6,0,0,1-5.7,18.7c-2.3-3.3-2.3-18.9-2.3-41.3,0-10.1.2-21.8.5-32.1l.1-2.8v-.1c1-32.7,3.6-67,5.8-90.4,1.5-15.8,6.6-63.3,7.2-67,.1-.8,1.1-1.6,1.2-2.1.4,2.9.8,7.4,1,13.1v.3l.2,5.9-2.6-2.4-1.7,10.2,4.3-.8ZM318.4,344.2c0,22.4,0,38-2.3,41.3a96,96,0,0,1-5.7-18.7,295.3,295.3,0,0,1-6.2-58.8v-.7L303,222.8l-.6-45V176l4.2.7-1.7-10.2-2.6,2.4a152.645,152.645,0,0,1,1.2-19.3c.1.6,1.1,1.3,1.2,2.1.6,3.7,5.8,51.2,7.2,67,2.2,23.8,5,59,5.9,92.3v1.1C318.2,322.4,318.4,334.1,318.4,344.2Z"
				fill="currentColor"
				opacity="0.8"
			/>
			<path
				id="Pfad_15"
				data-name="Pfad 15"
				d="M461,141.4s-10.4-25.8-72.8-25.8c-47.8,0-67.9,15.1-74.8,22.2a31.9,31.9,0,0,1,20.2-25,138,138,0,0,1,53.3-8.7c18.8,0,36.5,1.8,53.4,8.7A32.2,32.2,0,0,1,461,141.4Z"
				fill="currentColor"
				opacity="0.6"
			/>
			<path
				id="Pfad_16"
				data-name="Pfad 16"
				d="M405.1,124.7l-4.2-.3Zm51,19.9-.8-1Z"
				fill="#303e42"
			/>
			<path
				id="Pfad_17"
				data-name="Pfad 17"
				d="M403.9,216.8c-5.9-.3-11.7-.6-16.9-.6-21.8,0-55.1,3.8-57.8,4.3a3.767,3.767,0,0,1-2.8-.5c-1.3-.9-2.3-3.1-2.8-6.1-1.3-7.9-6.8-54.8-7.6-69l.2-.3c6.8-6.7,26.6-20.7,72-20.7h3.5c4.8,27.8,9.3,59.7,12.2,92.9Zm1.2-92.1-4.2-.3Zm51,19.9-.8-1Zm-57,286q-3.114,17.777-7.9,35.2l-4.2.1a77.5,77.5,0,0,1-50.9-20.4c-6.2-5.8-8.9-14-10-20.5l1.1.8.7.5.8.5.5.3.8.4.5.2.8.4.5.2,1.5.5.6.2,1.5.3c8,1,43.6,1.5,51.5,1.5Zm63.6-64a276,276,0,0,0,5.9-51.3L457,317.4l-.3,26.8c0,18.2,0,33.1,1.4,38.8A152.386,152.386,0,0,0,462.7,366.6Zm6.4-69.9,1-73.9v-.1l.5-39.7-3.9,1.2L463.1,219c-1.6,17.4-4.4,49.9-5.6,83ZM311.4,366.6a276,276,0,0,1-5.9-51.3l11.6,2.1.3,26.8c0,18.2,0,33.1-1.4,38.8A152.386,152.386,0,0,1,311.4,366.6ZM305,296.7l-1-73.9v-.1l-.5-39.7,3.9,1.2L311,219c1.6,17.4,4.4,49.9,5.6,83Z"
				fill="currentColor"
			/>
			<path
				id="Pfad_18"
				data-name="Pfad 18"
				d="M447.8,425.1a37,37,0,0,1-16.9,26.2l-1.1.8-1.3.9-1.3.8h-.1l-1.3.8-1.4.8-3,1.7-2.7,1.3-1.5.7-4.7,2-3,1.1-.2.1-1.5.5-1.6.5-1.6.5-1.7.4-1.7.4-3.2.6-3.6.5-1.4.1-2.1.2q4.781-17.4,7.9-35.2h11.5l4-.1h.1l2-.1,5.9-.2h1l2.4-.1h.9l4.4-.2h.9l2.2-.1h.6l.8-.1.8-.1,2-.2,1.6-.3.6-.2,1.5-.5.5-.2.8-.4.4-.2.9-.5,1.1-.7,1-.7.7-.5.4-.3Z"
				fill="currentColor"
				opacity="0.9"
			/>
			<path id="Pfad_19" data-name="Pfad 19" d="M399.1,430.6h0Z" fill="#fff" opacity="0.2" />
			<path
				id="Pfad_20"
				data-name="Pfad 20"
				d="M457.9,147.1c-1.1,16.4-6.2,59.3-7.4,66.8-.5,3.1-1.5,5.2-2.8,6.1a3.767,3.767,0,0,1-2.8.5h-.5l-1-.1-2.2-.3-.8-.1-.6-.1-1-.1-1.1-.1-1.7-.2-1.4-.1-2.5-.3-7.5-.7-1.6-.1-1.7-.2h-.5l-2.2-.2-.7-.1-3.3-.3h-.7l-2.2-.2-.8-.1-3.2-.2-1-.1-3-.2c-3-33.2-7.5-65.1-12.2-92.8h2.4l2.3.1,4.4.2,4.2.3,1.5.1,2,.2,2,.2,1.9.2.8.1,1.3.2,2.5.4,1.2.2,8,1.7h.1l2.9.8,2.7.8,3.7,1.3,1.2.5.2.1,1.1.4,2,.9,1,.5.3.2,1.7.8,1.8,1,.8.5,1.9,1.2,1.1.8.7.5.6.5,1.2.9,1.1.9,1,.9.4.4.4.4.4.4.4.4.3.4.8,1,1.2,1.6.3.5v.1l.6.6Z"
				fill="currentColor"
				opacity="0.9"
			/>
			<g id="Gruppe_1" data-name="Gruppe 1" opacity="0.3">
				<path
					id="Pfad_21"
					data-name="Pfad 21"
					d="M318,311.1v.2l-13.7-3.4-2-.5h-.1l-7.5,3.9-4.5,2.1v-.3l4.4-2,7.5-3.9h.1l2,.5,13.8,3.4Z"
					fill="currentColor"
					opacity="0.4"
				/>
			</g>
			<g id="Gruppe_2" data-name="Gruppe 2" opacity="0.3">
				<path
					id="Pfad_22"
					data-name="Pfad 22"
					d="M300.7,162.6v.3l-9.9-5.5v-.3Z"
					fill="currentColor"
					opacity="0.4"
				/>
			</g>
			<g id="Gruppe_3" data-name="Gruppe 3" opacity="0.3">
				<path
					id="Pfad_23"
					data-name="Pfad 23"
					d="M313.1,136.3l-.2.2-9.5-11.1,1.1-27v-.9l.2.6V99l-1.1,26.4Z"
					fill="currentColor"
					opacity="0.4"
				/>
			</g>
			<g id="Gruppe_4" data-name="Gruppe 4" opacity="0.3">
				<path
					id="Pfad_24"
					data-name="Pfad 24"
					d="M470.7,127.7l-9.6,8.5-.2-.2,9.5-8.4-1.6-28.2v-.9l-.2-2.4h.3L469,98v.8Z"
					fill="currentColor"
					opacity="0.4"
				/>
			</g>
			<g id="Gruppe_5" data-name="Gruppe 5" opacity="0.3">
				<path id="Pfad_25" data-name="Pfad 25" d="M471.5,162.8v.3h-.1l-.1-.2Z" fill="#2d383b" />
				<path
					id="Pfad_26"
					data-name="Pfad 26"
					d="M483.2,157.4v.3l-9.8,4.5v-.3Z"
					fill="currentColor"
					opacity="0.4"
				/>
			</g>
			<g id="Gruppe_6" data-name="Gruppe 6" opacity="0.3">
				<path
					id="Pfad_27"
					data-name="Pfad 27"
					d="M469.9,306.2v.4l-.2-.1-13.5,3v-.3l13.6-3Zm13.8,6.7v.3l-11.9-5.7v-.3Z"
					fill="currentColor"
					opacity="0.4"
				/>
			</g>
			<g id="Gruppe_7" data-name="Gruppe 7" opacity="0.3">
				<path
					id="Pfad_28"
					data-name="Pfad 28"
					d="M301.1,443.8l.2.3h-.1l-3.7-1.2-8.7-18.1v-.7l9,18.7,3.3,1Zm157.6-15.6-.2.5a56.482,56.482,0,0,0-2.8-13c-2.4-6.6-7.3-14.5-16.9-15.5H337s-7.5,1.2-11,3.6c-3.4,2.2-6.6,10-8,16.1-.5,2.3-1.4,5.8-2.4,9.1l-.2-.4,2.3-8.8c1.4-6.3,4.6-13.9,8.1-16.2a33,33,0,0,1,10.3-3.5l.8-.1H438.6c7.8.7,13.7,6.1,17.2,15.6a55.7,55.7,0,0,1,2.9,12.6Zm26.3-.9v.6l-8.7,15.4h-.1l-3-.2.1-.3,2.8.1,8.9-15.6Z"
					fill="currentColor"
					opacity="0.4"
				/>
			</g>
			<path
				id="Pfad_29"
				data-name="Pfad 29"
				d="M337,400.1h-2.3s-3.8-106.6-5.4-129.2c-1.4-20.1-4.1-43.6-4.6-48.5a7,7,0,0,0,1.7.9l.3.1.4.1c.8,6.6,3.2,28.5,4.5,47.4q3.273,64.575,5.4,129.2Zm111.2-177c-.7,6.2-3.2,28.5-4.6,47.8-1.6,22.1-5.2,124.7-5.4,129v.1h-2.3v-.1c.2-4.3,3.8-106.9,5.4-129,1.3-18.8,3.8-40.5,4.5-47.3l1-.1a3.708,3.708,0,0,0,1.4-.4Z"
				fill="currentColor"
				opacity="0.4"
			/>
			<path
				id="Pfad_30"
				data-name="Pfad 30"
				d="M477.6,170.8,476.4,182l-2.8-4-1.4-2h-.5l-4.3.8,1.7-10.2,2.6,2.4,1.3,1.3h.6Zm-170.9,6-4.2-.8h-.6l-1.4,2-2.8,4-1.2-11.2,4-.5h.6l1.4-1.3,2.5-2.4Z"
				fill="currentColor"
				opacity="0.8"
			/>
			<path id="Pfad_31" data-name="Pfad 31" d="M436.8,28l-.8-.6Z" fill="url(#linear-gradient-5)" />
			<path
				id="Pfad_32"
				data-name="Pfad 32"
				d="M440.8,27.7l-.5-.2-.5-.2-.5-.1-.9-.1h-.2l-.5.1-.3.1-.2.1-.2.2-.2.3-.8-.6-.1-.1-2.1-1.5-.8-.5-.4-.2-.8-.5-.4-.2-.6-.3-2.3-1.2-.3-.1a54,54,0,0,0-8.7-3.1,134.845,134.845,0,0,0-65.2,0l-2.2.6a30,30,0,0,0-3.2,1.1l-2.3.9-.7.3-2.7,1.3-.9.5-.5.3h-.1l-.2.1A22.3,22.3,0,0,0,337,28l-.2-.3-.2-.2-.4-.2-.2-.1h-1.1l-1.5.4-.3.1a39,39,0,0,1,21.4-11.4,139.4,139.4,0,0,1,64.8,0,40.6,40.6,0,0,1,21.5,11.4Z"
				fill="currentColor"
				opacity="0.8"
			/>
			<path id="Pfad_33" data-name="Pfad 33" d="M436.8,28l-.8-.6Z" fill="#263133" />
			<path
				id="Pfad_34"
				data-name="Pfad 34"
				d="M463.4,70.8l-.2-.9-.3-.9.3,1.2.4,1.5-.2-.9Zm.1-22.3.4.6Zm1.7,29.8-.2-.8.3,1.4-.1-.6Zm1.3,6-.1-.5.1.5.1.8Zm1.3,7.7-.1-.5v.3l.1.4Zm1.2,6-.1-1.9h-.3l.1,2.4v.8l.2-.5.1-.8Z"
				fill="#556063"
			/>
			<path
				id="Pfad_35"
				data-name="Pfad 35"
				d="M466.6,85.1l-.2-.8-.1-.5.1.5Z"
				fill="url(#linear-gradient-6)"
			/>
			<path id="Pfad_36" data-name="Pfad 36" d="M467.8,92v0Z" fill="url(#linear-gradient-7)" />
			<path
				id="Pfad_37"
				data-name="Pfad 37"
				d="M468.9,96.1,469,98l-.2.6-.1-2.4Z"
				fill="url(#linear-gradient-8)"
			/>
			<path id="Pfad_38" data-name="Pfad 38" d="M463.8,49l-.4-.6Z" fill="url(#linear-gradient-9)" />
			<path
				id="Pfad_39"
				data-name="Pfad 39"
				d="M463.6,71.7l-.4-1.5-.3-1.2.3.9.2.9.2.9Z"
				fill="url(#linear-gradient-10)"
			/>
			<path
				id="Pfad_40"
				data-name="Pfad 40"
				d="M465.4,78.9l-.3-1.4.2.8.1.6Z"
				fill="url(#linear-gradient-11)"
			/>
			<path
				id="Pfad_41"
				data-name="Pfad 41"
				d="M467.9,92.2l-.1-.4v-.3l.1.5c-.1.1-.1.1,0,.2Z"
				fill="url(#linear-gradient-12)"
			/>
			<path
				id="Pfad_42"
				data-name="Pfad 42"
				d="M469,98l-.2.6-.1-2.4h.3V98Z"
				fill="url(#linear-gradient-13)"
			/>
			<path
				id="Pfad_43"
				data-name="Pfad 43"
				d="M475.4,413.4c0,3.9-.4,22.5-.9,26.1a15.333,15.333,0,0,1-1.1,3.5l-.1.3c-1.4,3-4.1,6.4-8.4,9.9a138.8,138.8,0,0,1-22.7,12.5l1.4-2.8,5.3-10.8.7-1.5.4-.8.7-1.5c3.5-8,3.3-8.7,7.4-18.5l.4-1,.2-.5c4.4-9.5,13.4-21.2,15-21.1h.1c1.5,0,1.6,2.3,1.6,6.2ZM331.9,465.6c-.5-.2-16.5-7.4-22.7-12.5a32.2,32.2,0,0,1-7.9-9l-.2-.3a15.842,15.842,0,0,1-1.5-4.3c-.5-3.5-1-22.1-1-26.1,0-3.8.1-6.1,1.7-6.3h.1c1.6-.1,10.8,12,15.2,21.6l.2.4.3.7c4.1,9.8,3.9,10.4,7.4,18.5l.5,1,.6,1.3.7,1.5c.7,1.5,1.4,3.1,2.2,4.5l1,2,2.2,4.3,1.2,2.7Z"
				fill="currentColor"
				opacity="0.8"
			/>
			<path
				id="Pfad_44"
				data-name="Pfad 44"
				d="M463.1,69.9l.2.9-.2-.6Z"
				fill="url(#linear-gradient-14)"
			/>
			<path
				id="Pfad_45"
				data-name="Pfad 45"
				d="M466.5,84.3l-.1-.5Z"
				fill="url(#linear-gradient-15)"
			/>
			<path
				id="Pfad_46"
				data-name="Pfad 46"
				d="M463.1,69.9l.2.9-.2-.6Zm3.4,14.4-.1-.5Z"
				fill="#fff"
				opacity="0.8"
			/>
			<path
				id="Pfad_47"
				data-name="Pfad 47"
				d="M470.9,91.4c-.1,2.1-1.4,5.3-1.9,6.6l-.1-1.9h-.3l.1,2.4-.1-.8v-.3l-.3-2-.3-1.7v-.2l-.1-.5-.1-.7v-.4l-.1-.5-.1-.5v-.2l-.1-.5-.2-1.1-.1-.5-.1-.5v-.2l-.1-.5v-.1l-.2-.8-.1-.7-.2-.8-.1-.8-.1-.5-.2-.8-.3-1.3-.3-1.4-.3-1.2v-.2l-.1-.7-.2-.8-.5-2.2-.3-1.1-.4-1.6-.2-.8v-.1l-.2-.9-.2-.9-.3-.9-.1-.3-.2-.8-.5-1.5-.2-.7-.3-1.1-.4-1.2-.5-1.5-2.1-5.4-.5-1.2-.1-.2-.7-1.4-1.4-2.7-.5-.9c-1.4-2.4-2.8-4.7-4.1-6.6l-.6-.9-1.2-1.6-.7-.8-.7-.8-1.6-1.9-1.6-1.7-.8-.8-.4-.4-.3-.4-.5-.5-3.5-3.2a3,3,0,0,0-.7-.5,7.863,7.863,0,0,0-1.5-1.1s-.1-1.5,2.8-.5,12,5,17.8,12.6l.8,1,1.3,1.8,2,2.8,1,1.4.4.6.4.6a36,36,0,0,1,6.6,17l.5,8.3v4.4a94.559,94.559,0,0,1,.2,12.7Z"
				fill="currentColor"
				opacity="0.2"
			/>
			<path
				id="Pfad_48"
				data-name="Pfad 48"
				d="M466.6,85.1l-.2-.8-.1-.5.1.5Z"
				opacity="0.5"
				fill="url(#linear-gradient-16)"
			/>
			<path
				id="Pfad_49"
				data-name="Pfad 49"
				d="M467.8,92v0Z"
				opacity="0.5"
				fill="url(#linear-gradient-17)"
			/>
			<path
				id="Pfad_50"
				data-name="Pfad 50"
				d="M468.9,96.1,469,98l-.2.6-.1-2.4Z"
				opacity="0.5"
				fill="url(#linear-gradient-18)"
			/>
			<path
				id="Pfad_51"
				data-name="Pfad 51"
				d="M334.9,30ZM307.2,84.3l-.1.8.1-.8.1-.5ZM305.9,92v.3l.1-.4Zm-1.4,5.5v.9l.1.3.1.3v-.9l-.2-.6Z"
				fill="#556063"
			/>
			<path
				id="Pfad_52"
				data-name="Pfad 52"
				d="M307.3,83.8l-.1.5-.2.8.1-.8Z"
				fill="url(#linear-gradient-19)"
			/>
			<path
				id="Pfad_53"
				data-name="Pfad 53"
				d="M305.9,91.8l-.1.4v-.3Z"
				fill="url(#linear-gradient-20)"
			/>
			<path
				id="Pfad_54"
				data-name="Pfad 54"
				d="M336.4,28.8l-1.5,1.1q-1.629,1.367-3.2,2.8l-.1.1-1.1,1A74.4,74.4,0,0,0,325,40l-.7.8A75,75,0,0,0,317.2,52l-.8,1.6-.8,1.6-.4,1-.1.2a7,7,0,0,0-.5,1.3l-.5,1.2L313,61.8l-.3,1-1,3.2-.1.3-.5,1.5-.5,1.9v.1l-.5,1.9-.1.5-.3,1.3-.1.5-.3,1.1-.4,1.5-.1.5-.4,1.6-.1.6-.6,2.9-.3,1.3-.1.5-.1.8-.2.8-.1.7-.1.7-.1.3-.1.6-.3,1.5-.1.6-.2,1.4v.7l-.1.7-.1.5v.2q-.239,1.859-.6,3.7v.3l-.1.8-.2-.4-.2-.6a27.2,27.2,0,0,1-1.8-6.1l-.1-2.6-.1-3v-8l.1-2.7.1-2.7.1-2,.1-1.3.3-3.3.4-2.8a36,36,0,0,1,6.3-14.2l3.8-5.3,1.3-1.8.8-1a41,41,0,0,1,17.8-12.6c2.7-.6,2.6.9,2.6.9Z"
				fill="currentColor"
				opacity="0.2"
			/>
			<path
				id="Pfad_55"
				data-name="Pfad 55"
				d="M307.3,83.8l-.1.5v.1Z"
				fill="url(#linear-gradient-21)"
			/>
			<path
				id="Pfad_56"
				data-name="Pfad 56"
				d="M335,29.9l-2.4,2,2.4-2C334.9,30,334.9,29.9,335,29.9Z"
				fill="url(#linear-gradient-22)"
			/>
			<path
				id="Pfad_57"
				data-name="Pfad 57"
				d="M307.3,83.8l-.1.5v.1ZM335,29.9l-2.4,2,2.4-2C334.9,30,334.9,29.9,335,29.9Z"
				fill="#fff"
				opacity="0.8"
			/>
			<path
				id="Pfad_58"
				data-name="Pfad 58"
				d="M307.3,83.8l-.1.5-.2.8.1-.8Z"
				opacity="0.5"
				fill="url(#linear-gradient-23)"
			/>
		</g>
	</svg>
);
